import { inject, Injectable } from '@angular/core';
import { DocumentState } from '@documents/reducer/documents.reducer';
import { UPLOAD_DIALOG_ACTIONS } from '@documents/actions/';
import { UploadDialogData } from '@shared/dialogs/types/upload-document-data.types';
import { Store } from '@ngrx/store';
import { WcgUploadDocumentComponent } from '../components/upload-document/upload-document.component';

@Injectable()
export class UploadDialogService {
  private readonly _store = inject(Store<DocumentState>);

  open(data: UploadDialogData) {
    this._store.dispatch(
      UPLOAD_DIALOG_ACTIONS.openUploadDialog({
        data,
        component: () => WcgUploadDocumentComponent,
      }),
    );
  }
}
